import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/website/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/website/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/app/website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/website/node_modules/next/dist/client/image-component.js");
